import { Plan } from './plan.constants';

export enum UserPermission {
	NONE = 'None',
	UNPERMITTED = 'Unpermitted',
	SIGNUPER = 'Signuper',
	VIEWER = 'Viewer',
	OPERATIONER = 'Operationer',
	SIGNER = 'Signer',
}

export interface User {
	given_name: string;
	family_name: string;
	iat: number;
	oid: string;
	companyId: number;
	companyName: string;
	companyCreationDate: Date;
	companyBankAccount: string;
	companyIdentityNumber: string;
	companyAccountId: number;
	plan: Plan | null;
	planId: string | null;
  planNextMonthId: string | null,
  planNextMonth: Plan | null,
	role: string;
	email: string;
	phone: string;
	language: string;
	isCreditCardUpdated?: boolean;
	companyHebrewName?: string;
}
